import React from 'react';

const badges = [
  { id: 1, name: 'Pro Mentor', icon: '🥇', unlocked: true },
  { id: 2, name: 'Signal Leader', icon: '📈', unlocked: true },
  { id: 3, name: 'Investor Verified', icon: '🔐', unlocked: false },
  { id: 4, name: 'KYC Verified', icon: '✅', unlocked: true },
];

export default function BadgeShowcase() {
  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-md font-semibold mb-3">🏅 Your Badges</h3>
      <div className="flex flex-wrap gap-4">
        {badges.map((badge) => (
          <div
            key={badge.id}
            className={`flex flex-col items-center justify-center w-24 h-24 rounded-lg border text-center p-2 ${
              badge.unlocked ? 'bg-green-50 border-green-400' : 'bg-gray-100 border-gray-300'
            }`}
          >
            <div className="text-2xl">{badge.icon}</div>
            <span className="text-xs mt-1 font-medium text-gray-700">{badge.name}</span>
            {!badge.unlocked && (
              <span className="text-[10px] text-gray-400 mt-1">Locked</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
